import { LocaleMessages } from 'shared-locales';

const getVuoadminLoginReasons = (messages: LocaleMessages) => ({
  'user-management': messages.authVuoadminLoginReasonUserManagement,
  'support-request': messages.authVuoadminLoginReasonSupportRequest,
  consultation: messages.authVuoadminLoginReasonConsultation,
  'inspecting-or-updating-settings':
    messages.authVuoadminLoginReasonInspectingOrUpdatingSettings,
  'inspecting-an-issue': messages.authVuoadminLoginReasonInspectingAnIssue,
  'updating-server-settings':
    messages.authVuoadminLoginReasonUserUpdatingServerSettings,
  other: messages.authVuoadminLoginReasonOther
});

export default getVuoadminLoginReasons;
